import type { TOC } from '@ember/component/template-only'
import { StudentDashboardTile } from 'teacher-ui-client/components/tiles/student-dashboard'
import { TaskState } from 'teacher-ui-client/components/task-state'
import { StudentAssessmentsOverview } from 'teacher-ui-client/components/reporting/reading-eggspress/dashboard/student/assessments/overview'
import { StudentDashboardSubheader } from 'teacher-ui-client/components/tiles/student-dashboard/subheader'
import { StudentAssessmentsEventsDetailed } from 'teacher-ui-client/components/reporting/reading-eggspress/dashboard/student/assessments/events-detailed'
import { BasePageSelector } from 'teacher-ui-client/components/base/page-selector'
import { themeKey } from 'teacher-ui-client/helpers/theme-key'
import { t } from 'ember-intl'
import type { Task } from 'ember-concurrency'
import type {
  AssessmentsEventsReportData,
  AssessmentsOverviewReportData,
} from 'teacher-ui-client/reporting/ui-scope/rex/dashboard/student/index/route'

interface Args {
  fetchAssessmentsOverviewReportTask: Task<AssessmentsOverviewReportData | undefined, unknown[]>
  fetchAssessmentsEventsReportTask: Task<AssessmentsEventsReportData | undefined, unknown[]>
}

interface Signature {
  Args: Args
}

export const DashboardStudentAssessmentsPage: TOC<Signature> = <template>
  <StudentDashboardTile
    data-test-student-dashboard-tile="assessments"
    @theme={{themeKey "reading"}}
    @title={{t "pages.reporting.readingEggspress.dashboard.student.assessments.title"}}
    @icon="phosphor-share-network-fill"
  >
    <TaskState @task={{@fetchAssessmentsOverviewReportTask}} @initialLoadingClass="m-3" as |lastValue isRunning|>
      <StudentAssessmentsOverview class="w-full" @overviewData={{lastValue.overview}} @isLoading={{isRunning}} />
    </TaskState>
    <StudentDashboardSubheader>
      {{t "pages.reporting.readingEggspress.dashboard.student.recentActivity"}}
    </StudentDashboardSubheader>
    <TaskState @task={{@fetchAssessmentsEventsReportTask}} @initialLoadingClass="m-3" as |lastValue isRunning|>
      <StudentAssessmentsEventsDetailed class="w-full" @eventsData={{lastValue.events}} @isLoading={{isRunning}} />
      <BasePageSelector
        class="my-4"
        @pageCount={{lastValue.meta.total_pages}}
        @itemCount={{lastValue.meta.total_entries}}
      />
    </TaskState>
  </StudentDashboardTile>
</template>

export default DashboardStudentAssessmentsPage
